const getDateTime = (timeZone) => {
  return moment.utc().tz( timeZone );
}

const parseDateTime = (dateTime, format) => {
  return moment.utc(dateTime, format);
}

const daysToSeconds = (days) => {
  return moment.duration(days,'d').asSeconds();
}

const timeToSeconds = (time) => {
  return moment.duration( time ).asSeconds();
}

const secondsToTime = (seconds) => {
  return moment.utc( moment.duration(seconds, 'seconds').asMilliseconds() );
}

const shiftDays = (dateTime, shift) => {
  return moment.utc(dateTime).add(shift, 'days');
}

const timeToString = (time, format = 'HH:mm:ss') => {
  return time.format(format);
}

const isDayBetween = (now, start, end) => {
  const dateNow = moment.utc({ year: now.year(), month: now.month(), day: now.date() });
  const dateStart = moment.utc({ year: start.year(), month: start.month(), day: start.date() });
  const dateEnd = moment.utc({ year: end.year(), month: end.month(), day: end.date() });
  return dateNow.isBetween(dateStart, dateEnd) || dateNow.isSame(dateStart) || dateNow.isSame(dateEnd);
}

// nd=0 ... sb=6
const dayIndex = (dateTime) => {
  const dayIso = dayIndexIso(dateTime);
  return dayIso > 6 ? 0 : dayIso;
}

// pn=1 ... nd=7
const dayIndexIso = (dateTime) => {
  return dateTime.isoWeekday();
}

export default { 
  getDateTime,
  parseDateTime,
  daysToSeconds,
  timeToSeconds,
  secondsToTime,
  shiftDays,
  timeToString,
  isDayBetween,
  dayIndex,
  dayIndexIso
}
